import React from 'react';

import { EUserStoreRole } from '@domain/enums/common/userStore/EUserStoreRole';

import { useStoreConfig } from '@helpers/hooks/useStoreConfig';
import { useConfig } from '@helpers/hooks/useConfig';

import { CustomValuesOutProvider } from '@helpers/hooks/pages/dashboard/customValues/useCustomValuesOut';

import Wrapper from '@components/Dashboard/CustomValues/Out/Wrapper';
import NoAccess from '@components/common/core/Utils/NoAccess';

const Out: React.FC = () => {
  const { accessManagementData } = useStoreConfig();
  const { isInternalTeam } = useConfig();

  const isStoreOwner = accessManagementData?.role === EUserStoreRole.OWNER;
  const hasAccessToPage =
    accessManagementData?.group?.has_custom_value_full_write_access ||
    accessManagementData?.group?.has_custom_value_full_read_access;

  if (!isStoreOwner && !hasAccessToPage && !isInternalTeam) {
    return <NoAccess />;
  }

  return (
    <CustomValuesOutProvider>
      <Wrapper />
    </CustomValuesOutProvider>
  );
};

export default Out;
